import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'user'
})
export class UserPipe implements PipeTransform {

  transform(userName: string, dots:boolean = false): string {
    if(!userName || userName == ' ' || userName == 'Null') return '-';
    if(dots) return `${userName} ...`;
    return userName;
  }

}
